import axios from './axios';

export const getChangeCount = async (token) => {
  try {
    const response = await axios.get('/change_counts', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getBasicCounts = async (token) => {
  try {
    const response = await axios.get('/basic_data_counts', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};
